module.exports = __webpack_public_path__ + "static/media/github2.148afbb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Home/images/github2.png
// module id = 80
// module chunks = 0